<div class="sd-headline sd-headline--size-base">
  {{ data.title }}
</div>

@if (data.subtitle) {
  <div class="sd-meta sd-meta--size-sm sd-meta--light">
    {{ data.subtitle }}
  </div>
}

@switch (data.type) {
  @case (FilterType.Checkbox) {
    <sd-4-5-1-checkbox-group
      [(wctSdCheckboxGroupModel)]="selection[data.title]"
      (wctSdCheckboxGroupModelChange)="dirty.next()">
      <div
        class="option-grid"
        [style]="data | filterGrid">
        @for (option of data.options; track $index) {
          <sd-4-5-1-checkbox
            value="{{ option }}"
            [sd-checkbox-value-injector]="update$ | getArraySelectionValue: data.title : option : selection">
            {{ option }}
          </sd-4-5-1-checkbox>
        }
      </div>
    </sd-4-5-1-checkbox-group>
  }
  @case (FilterType.Radio) {
    <sd-4-5-1-radio-group
      [(wctSdModel)]="selection[data.title]"
      (wctSdModelChange)="dirty.next()">
      <div
        class="option-grid"
        [style]="data | filterGrid">
        @for (option of data.options; track $index) {
          <sd-4-5-1-radio value="{{ option }}">{{ option }}</sd-4-5-1-radio>
        }
      </div>
    </sd-4-5-1-radio-group>
  }
  @case (FilterType.String) {
    <sd-4-5-1-input
      placeholder="{{ data.title }}"
      [(wctSdModel)]="selection[data.title]"
      (wctSdModelChange)="dirty.next()"></sd-4-5-1-input>
  }
  @default {
    unimplemented filter
  }
}
